import React, { useState, useEffect, useRef } from "react";
import FileUploader from "../../components/FileUploader/FileUploader";
import DropdownList from "../../components/DropdownList/DropdownList";
import DynamicInput from "../../components/DynamicInput/DynamicInput";
import CustomTooltip from '../../components/ToolTip/CustomTooltip'; 
import { downloadFile } from "../../services/GenericAPI";
import { useDispatch } from "react-redux";
import { setIsProposalDetailsPartiallyFilled } from "./ApplyBriefSlice";
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';
import { formatCurrency } from "../../util/util";
const ProposalDetails = ({
  details,
  handleTextArea,
  onFormDataChange,
  submitTrigger,
  currentList,
  maxChar,
  formValues,
  data,
  currencyData,
  fileUpload,
  episodeShow,
  productionType=''
}) => {
  const formRef = useRef(null);  // Create a ref for the form
  const [touched, setTouched] = useState({});
 const { Globals ,languages, setLanguages } = useLanguage();
  const [documents, setDocuments] = useState(data?.documents);
  const [visibleUploaders, setVisibleUploaders] = useState(
    data?.documents || []
  );
  const dispatch = useDispatch();
// Function to remove specific keys from formData
const removeKeys = (keysToRemove) => {
  const updatedFormData = { ...formData }; // Create a copy of formData
  keysToRemove.forEach((key) => {
    delete updatedFormData[key]; // Remove each key
  });
  setFormData(updatedFormData); // Update the state
};

// Usage example
useEffect(() => {
  const keysToRemove = ["showReel", "regulatoryDocument", "certCopyRightRegistration"];
  removeKeys(keysToRemove);
}, []); // This will run once when the component mounts
  function displayFileNames(documentFor) {
    const filteredFiles = visibleUploaders.filter((item) => item.documentFor === documentFor);
    return filteredFiles
  }
  const [formData, setFormData] = useState(data || {});
  const [errors, setErrors] = useState({});
  const [info, setInfo] = useState(false);

  useEffect(() => {
    // if (submitTrigger) {
      handleSubmit();
    // }
  }, [submitTrigger]);

  const handleRemoveClick = (documentId) => {
    setVisibleUploaders((prev) => ({
      ...prev,
      [documentId]: true, // Set the specific FileUploader to visible
    }));
  };

  const handleFileInput = (file, type) => {
  console.log("Incoming File:", file);
  console.log("File Type:", type);

  const fileValue = file && Object.keys(file).length > 0 ? file : undefined;

  console.log("Processed File Value:", fileValue);

  if (type === 'lookbookpdfOrDocOnly') {
    fileUpload("lookBoardMoodBaord1", file);
  } else {
    fileUpload("productionSchedule1", file);
  }
};

  const filterCurrency = (value) => {
     const index = currencyData?.Currencies?.findIndex(item => item.name === value)
    if (index !== -1) {
        return { item: currencyData?.Currencies?.[index], index };
    }
    return null;
};
  const handleChange = (key, value) => {
    let newFormData;
    if(key === 'currencyId'){
      const filteredItem = filterCurrency(value);
      newFormData = {
            ...formData,
            [key]: filteredItem?.item?.id || ""
        };
    }
    else if (key === 'targetBudget' && value.length <= 15) {
      let numericValue;
      if (value === "" || !value) {
        numericValue = 0;
      }
      numericValue = value && value.replace(/,/g, "");
      const regex = /^\d+(\.\d{0,2})?$/;
      if (regex.test(numericValue) && numericValue.length <= 15 && (numericValue !== "0" || numericValue === "")) {
        const formattedCurrency = formatCurrency(numericValue);
        newFormData = {
          ...formData,
          [key]: formattedCurrency,
        };
      }
      else {
        newFormData = {
          ...formData,
          [key]: 0,
        }
      }
    }
    else{
      newFormData = {
        ...formData,
        [key]: value,
      };
    }

    setFormData(newFormData);
     setTouched((prev) => ({ ...prev, [key]: true }));
  
    // Validate input and set error message (if any)
    const error = validateInput(details, key, value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [key]: error,
    }));
  
    onFormDataChange(newFormData, value);
  };
  
  const handleTitleSelection = (key, value) => {
    handleChange(key, value.trim());
  };

  const validateInput = (details, key, value) => {
    // Function to find the field within nested groups
    const findField = (details, key) => {
      for (const item of details) {
        if (item.key === key) {
          return item;
        }
        if (item.type === "group") {
          const groupItem = item.items.find(subItem => subItem.key === key);
          if (groupItem) {
            return groupItem;
          }
        }
      }
      return null;
    };
  
    const field = findField(details, key);
    if (field && (!value || value === Globals.APPLY_BRIEF.CURRENCY)) {
      return field.errorMessage || "This field is required.";
    }
    if (key === "targetBudget" && value < 0) {
      return "Preliminary Budget cannot be a negative number.";
    }
    return "";
  };

  const doc = (data, key) => {
    const fil = data?.documents?.filter((item) => key === item.documentFor);
    const fileName = fil?.[0]?.documentPath.split('/').pop();
    return fileName;
  };

  const handleInfoButton = () => {
    setInfo(true);
  };
  const handleFileRemove=(type)=>{
    if(type==='lookbookpdfOrDocOnly'){
      fileUpload("lookBoardMoodBaord1",'')
      }else{
        fileUpload("productionSchedule1",'')
      }
  }
  const downloadSelectedFile = (e,fileName) => {
    e?.preventDefault();
    // console.log(fileName)
    //   let path=fileName[0].documentPath
    //   downloadFile(path).then((response) => {
    //     if (response?.data?.status) {
    //       window.open(response.data.status, '_blank', 'noopener noreferrer');
    //     }
    //     else {
    //       console.error("Error in downloading the file or file does not exist to download")
    //     }
  
    //   }).catch((error) => {
    //     console.error("Error in downloading the file")
    //   })
    }
  const renderInput = (item, index) => {
    const isSmallWidth = item.title === "Currency" || item.title === "Preliminary Budget";
    const width = isSmallWidth ? "170px" : "350px";

    switch (item.type) {
      case "textarea":
        return (
          <DynamicInput
            key={index}
            type="textarea"
            label={item.title}
            isRequired={item.isRequired}
            defaultValue={" "}
            validate={validateInput}
            inputError={touched[item.key] ? errors[item.key]:""}
            className={`dropdown-width-300 ${isSmallWidth ? "small-width" : ""}`}
            onChange={(value) => handleChange(item.key, value)}
            onBlur={(value) => handleChange(item.key, value)}
            inputValue={formData[item.key] || ""}
            maxCount={item.maxChar}

          />
        );
      case "file":
        return (
          <div className="document-table-container">
           {data?.documents?.find(doc => doc.documentFor === item.fileKey)?.documentName ? 
  <FileUploader
    key={index}
    onClick2={(e)=>downloadSelectedFile(e,displayFileNames(item.fileKey))}
    supportedFileType="pdfOrDocOnly"
    onFileUpload={(file) => handleFileInput(file, item.supportedFileType)}
    selectedClassName="apply-brief-file-selected"
    currentFile={item.content}
    fileDownload={displayFileNames(item.fileKey)}
    onFileRemove={()=>handleFileRemove(item.supportedFileType)}
  />
  :
  <FileUploader
    key={index}
    supportedFileType="pdfOrDocOnly"
    onFileUpload={(file) => handleFileInput(file, item.supportedFileType)}
    selectedClassName="apply-brief-file-selected"
    currentFile={item.content}
    onFileRemove={()=>handleFileRemove(item.supportedFileType)}
  />
}
          </div>
        );
      case "dropdown":
        return (
          <>
           <DropdownList
            key={index}
            options={currentList}
            placeHolderValue={" "}
            inputValue={currentList?.[currencyData?.Currencies?.findIndex(item => item.id === formData.currencyId)] || ""}
            onSelect={(value) => handleTitleSelection(item.key, value)}
            selectClass={`apply-brief-dropdown ${isSmallWidth ? "small-width" : ""}`}
            dropdowncontainerclass="dropdown-solicated"
            error={errors[item.key]} // Pass error message to DropdownList
            CustomDropdownimg={"unsolicted-img"}
            pattern=".*"
            onBlur = {(value) => handleTitleSelection(item?.key, value.target.innerText)}
            tabIndex={index}
          />
            {(touched[item.key] && errors[item.key]) && <p className="invalidCredential" style={{ margin: '5px 0px 0px', display: 'flex', alignItems: 'flex-start' }}> <img id="login-error" className="icon-style login-error solicited-dropdown-error" src={Globals.IMG.ERROR} alt="password error" />{errors[item.key]}</p>}
          </>
        );
      default:
        return (
          <DynamicInput
            key={index}
            type={item.key==='targetBudget'?"input":"text"} // Ensure type is "input"
            label={item.title}
            isRequired={item.isRequired}
            defaultValue={" "}
            validate={validateInput}
            inputError={touched[item.key] ? errors[item.key] : ""}
            className={`dropdown-width-300 ${isSmallWidth ? "small-width" : ""}`}
            onChange={(value) => handleChange(item.key, value)}
            onBlur={(value) => handleChange(item.key, value)}
            inputValue={item.key==='targetBudget'?formatCurrency(formData[item.key] || ""):(formData[item.key] || "")}
            width={width}
            maxCount={item.maxChar}
            inputMode={item.key === "targetBudget" ? "numeric" : "text"} // Ensure inputMode is numeric for targetBudget
           // pattern={item.key === "targetBudget" ? "\\d*" : ".*"} // Ensure pattern allows only numbers for targetBudget
           maxLength={item.key === "targetBudget" ? 15 : 100} // Set maxLength for targetBudget
          />
        );
    }
  };

  const renderGroup = (group, index) => (
    <div key={index} className="brief-apply2-card bg-white shadow-md rounded-lg col-span-3">
      <div className="flex flex-wrap" style={{gap:`${group.type==='group'?'20px':'0px'}`}}>
        {group.items.map((subItem, subIndex) => (
          <div key={subIndex} className="brief-apply2-item flex-1 min-w-1/2">
            <label className="block font-semibold text-sm mb-1">
              {getTranslatedDropdownKeys(subItem.title)}
              <span className="required"> *</span>
            </label>
            {renderInput(subItem, `${index}-${subIndex}`)}
          </div>
        ))}
      </div>
    </div>
  );

  const handleSubmit = () => {
    const newErrors = {};
    details.forEach((item) => {
      // Validate group items as well if the item type is "group"
      if (item.type === "group") {
        item.items.forEach((subItem) => {
          const error = validateInput(details, subItem.key, formData[subItem.key]);
          const ObjectKey=getFieldKeys(FallBackLabel.UNSOLICITED_ERROR_MSG, error);
          if (error) {
            console.log("Error =1==> ",Globals.UNSOLICITED_ERROR_MSG[ObjectKey]);
            newErrors[subItem.key] = Globals.UNSOLICITED_ERROR_MSG[ObjectKey];
          }
        });
      } else {
        const error = validateInput(details, item.key, formData[item.key]);
        const ObjectKey=getFieldKeys(FallBackLabel.UNSOLICITED_ERROR_MSG, error);
        if (error) {
          console.log("Error2 ===> ",Globals.UNSOLICITED_ERROR_MSG[ObjectKey]);
          newErrors[item.key] = Globals.UNSOLICITED_ERROR_MSG[ObjectKey];
        }
      }
    });
    setErrors(newErrors);
    // onFormDataChange(formData, Object.keys(newErrors).length === 0);
  
    // Scroll to top if the form is invalid
    if (Object.keys(newErrors).length > 0 && formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const doesFormHaveValue =
     (formData['projectTitle'] || '').length > 0 ||
      formData['logLine']?.length > 0 ||
      formData['synopsis']?.length > 0 ||
      formData['editorialDetails']?.length > 0 ||
      formData['lookbookAndMoodboard']?.length > 0 ||
      formData['currencyId'] > 0 ||
      formData['targetBudget']?.length > 0 ||
      formData['productionSchedule']?.length > 0 ||
      formData['locationStudioInfo']?.length > 0 ||
      formData['castPresenterInfo']?.length > 0 ||
      formData['brandIntegration']?.length > 0 ||
      formData['keyTeams']?.length > 0;
    dispatch(setIsProposalDetailsPartiallyFilled({ isProposalDetailsPartiallyFilled: doesFormHaveValue }))
  })

  const getFieldKeys = (obj,value) => {
    const trimmedValue = typeof value === 'string' ? value.trim() : value;
    return Object.keys(obj).find(key => {
      const objValue = obj[key];
      return typeof objValue === 'string' ? objValue.trim() === trimmedValue : objValue === trimmedValue;
    });
  }

  const getTranslatedDropdownKeys=(value)=>{
    const formattedData=value.replace(' ', '_');
    return Globals.APPLY_BRIEF_LABELS[formattedData.toUpperCase()];
  }

  const updatedDetails = details.map(detail => {
    if ((detail.title === Globals.BRAND_INTEGRATION|| detail.title==="Brand Integration Opportunities") && productionType !== Globals.ADVERTISER_PROGRAMME) {
        return { ...detail, isRequired: false };
    }
    else if ((detail.title === Globals.BRAND_INTEGRATION || detail.title==="Brand Integration Opportunities")&& productionType === Globals.ADVERTISER_PROGRAMME) {
      return { ...detail, isRequired: true };
    }
    else if ((detail.title === FallBackLabel.UNSOLICITED_PROPOSAL.PRODUCTION_SCHEDULE) && (detail.isRequired!==true)) {
      return { ...detail, isRequired: true }
    }
    return detail;
});
  return (
    <div ref={formRef} className="brief-container apply-brief-basic-info">
    <label className="Proposal-Title">{Globals.APPLY_BRIEF.PROPOSAL_DETAILS}</label>
      <div className="note-point">
        <label className="mandatory-field-declaration"><span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span>{Globals.MANDATORY_FIELD_TEXT}</label><br />
      </div>
    <div className="brief-apply2-container flex flex-wrap p-6">
      {updatedDetails?.map((item, index) => {
        const ObjectKey=getFieldKeys(FallBackLabel.APPLY_BRIEF_LABELS,item.title);
        if (!episodeShow && item.key === "episodeStructure") {
          return null; // Returning null to exclude episodeStructure items
        }
  
        return item.type === "group" ? (
          renderGroup(item, index)
        ) : (
          <div key={index} className="brief-apply2-card bg-white shadow-md rounded-lg flex-1 min-w-1/3">
            <h3 className="brief-apply2-title font-bold text-lg mb-2">
              <div className="brief-input-top-label">
                {Globals.APPLY_BRIEF_LABELS[ObjectKey]===Globals.UNSOLICITED_PROPOSAL.PRODUCTION_SCHEDULE?Globals.UNSOLICITED_PROPOSAL.PRODUCTION_SCHEDULE:Globals.APPLY_BRIEF_LABELS[ObjectKey]}
                {((item.isRequired) || (item.key === 'episodeStructure' && episodeShow)) && <span className="required"> *</span>}
                {item.isInfo && (
                  <CustomTooltip title={item.infoMessage}>
                    <img
                      src={Globals.IMG.INFO_ICON}
                      alt="info icon"
                      className="icon-style"
                      onClick={handleInfoButton}
                    />
                  </CustomTooltip>
                )}
                {/* {Globals.APPLY_BRIEF_LABELS[ObjectKey]===Globals.UNSOLICITED_PROPOSAL.PRODUCTION_SCHEDULE? <span className="required"> *</span>:""} */}
              </div>
            </h3>
            {renderInput(item, index)}
          </div>
        );
      })}
    </div>
  </div>
  
  );
};

export default ProposalDetails;
